import { Employee } from '@models/employee/employee.model';

export abstract class MeetingSchedulerService {
    abstract bookMeeting(employee: Employee): Promise<Date>;
}
